import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { listPrice } from '../data/valueStack';
export function UrgencyBar() {
  const {
    formatted,
    isExpired
  } = useCountdown(299);
  return <div role="status" aria-live="polite" className="sticky top-0 z-50 flex w-full items-center justify-center gap-2 border-b border-white/15 bg-gradient-to-r from-crimson-deep via-crimson to-crimson-deep px-3 py-1.5 text-center font-mono text-[9.5px] leading-tight tracking-[0.035em] text-[#fbe3e3] sm:gap-2.5 sm:text-[10.5px]" data-id="element-281" data-mp="37vjwzzoz91fs">
      <span className="h-[5px] w-[5px] shrink-0 rounded-full bg-[#ffd9d9] shadow-[0_0_7px_2px_rgba(255,180,180,0.85)] animate-pulse-dot" aria-hidden="true" data-id="element-282" data-mp="2u2lm1501x0r4" />
      <span className="hidden sm:inline" data-id="element-283" data-mp="2k822vxi8pr9n">
        ALERTA DE ACCESO: el subsidio de lanzamiento expira en
      </span>
      <span className="sm:hidden" data-id="element-284" data-mp="2f9iezrk365en">EL SUBSIDIO EXPIRA EN</span>
      <span className="rounded border border-white/25 bg-black/30 px-1.5 py-px font-bold text-[#ffe9b3]" data-id="element-285" data-mp="2b6vl7l3uuaet">
        {isExpired ? '00:00' : formatted}
      </span>
      <span className="hidden opacity-50 sm:inline" aria-hidden="true" data-id="element-286" data-mp="1wo0ykjtclsfg">
        |
      </span>
      <span className="hidden sm:inline" data-id="element-287" data-mp="1hz4u0wqi2xjl">
        100 cupos, luego <strong className="font-bold text-white" data-id="element-288" data-mp="1i0ppcokn2kii">${listPrice} USD</strong>
      </span>
    </div>;
}